<template>
  <div class="row py-3 px-md-5 mx-md-3">
    <div class="col-12 mb-5">
      <div class="row mb-5">
        <div class="col-md-4 text-center">
          <div class="row">
            <div class="col-12 my-md-3 text-center">
              <h3 class="my-md-5 my-3">Inventario <br/> Diferencial</h3>
            </div>
            <div class="col-12 my-md-3 text-center">
              <h2 class="my-md-5 my-3">EDWARDS</h2>
            </div>
          </div>
          <div class="row d-none d-md-block">
            <div class="col-12 mt-3 text-center">
              <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
            </div>
          </div>
        </div>
        <div class="col-md-8 mt-3">
          <ul class="nav nav-tabs px-3" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Instrucciones</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Ejemplo</a>
            </li>
          </ul>
          <div class="tab-content px-3" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div class="row mt-3">
                <div class="col-12 text-center">
                  <b>Instrucciones</b>
                </div>
                <div class="col-12 mt-3">
                  A continuación encontrará 225 pares de frases, usted debe escoger cada par aquella frase que sea más afín con su forma de ser o de pensar. A veces tendrá la impresión de que ninguna refleja esa afinidad o, al contrario, que ambas lo hacen;en todo caso usted debe optar por una de las dos. No hay respuestas correctas o incorrectas (cada persona tiene un modo de ser distinto). Por tanto, conteste con sinceridad.
                </div>
                <div class="col-12 text-center mt-3">
                  <b>Al contestar tenga en cuenta lo siguiente</b>
                </div>
                <div class="col-12 mt-3">
                  No piense demasiado las pregntas ni emplee mucho tiempo en decidirse; debe contestar pensando en lo que es habitual para usted.
                </div>
                <div class="col-12 mt-3">
                  Conteste sinceramente. No señale sus respuestas pensando en lo que "es bueno" o "lo que interesa" para impresionar al examinador.
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <div class="row mt-3">
                <div class="col-12 mt-2">
                  <b>Seleccionar respuesta:</b>
                </div>
                <div class="col-12 mt-2">
                  1. Posicione la flecha del mouse sobre la frase que le describe más.
                </div>
                <div class="col-12 mt-2">
                  2. Presione el botón izquierdo del mouse para quitar la marca de la frase.
                </div>
                <div class="col-12 mt-2">
                  <b>Cancelar respuesta:</b>
                </div>
                <div class="col-12 mt-2">
                  1. Posicione la flecha del mouse en la marca de la actividad a cancelar.
                </div>
                <div class="col-12 mt-2">
                  2. Presione el botón izquierdo del mouse para quitar la marca a la frase.
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col" class="text-center">Frase</th>
                        <th scope="col" class="text-center">Me describe más</th>
                      </tr>
                    </thead>
                    <tbody v-for="pregunta of ejemplo.preguntas" v-if="pregunta.active">
                      <tr v-for="opcion of pregunta.opciones">
                        <td>{{pregunta.numero}}</td>
                        <td>{{opcion.nompregunta}}</td>
                        <td v-on:click="Seleccionar_Respuesta(pregunta.numero, opcion.identificador)" class="text-center">
                          <i v-if="opcion.respuesta===true" class="fas fa-check"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5 text-center d-block d-md-none">
          <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      ejemplo:{
        preguntas:[
          {
            numero: 1,
            active: true,
            opciones:[
              {
                identificador :'A',
                nompregunta:'Me gusta hablar de mi a otro',
                respuesta: ''
              },
              {
                identificador:'B',
                nompregunta:'Me gusta trabajar para lograr una meta que me he puesto',
                respuesta: ''
              }
            ]
          }
        ]
      }
    }
  },
  methods:{
    Seleccionar_Respuesta(numero_pregunta, identificador){ 
      const pregunta = this.ejemplo.preguntas.filter(function (pregunta) {
            return pregunta.active == true;
        })

      if (identificador === 'A') {
        if (pregunta[0].opciones[0].respuesta==true) {
          pregunta[0].opciones[0].respuesta = false;  
        }else{
          pregunta[0].opciones[0].respuesta = true
          pregunta[0].opciones[1].respuesta = false

        }
      }
      else if (identificador === 'B') {
        if (pregunta[0].opciones[1].respuesta==true) {
          pregunta[0].opciones[1].respuesta = false;  
        }else{
          pregunta[0].opciones[0].respuesta = false
          pregunta[0].opciones[1].respuesta = true
        }
      }
    },
    Iniciar_Examen(){
      this.$router.push({name:'edwards_preguntas'});
    },
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	}
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Examenes/Edwards/Instrucciones.vue